import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=6528f67f&scoped=true&"
import script from "./ConfirmModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ConfirmModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6528f67f",
  null
  
)

export default component.exports